var Backbone = require('backbone'),
    SearchModel = require('./SearchModel');


/* The collection stored on the state model */

module.exports = Backbone.Collection.extend({

    model: SearchModel,

    /* Now unused */
    allAreSearched: function() {

        return this.every( function(s) {
            return s.get('inResults');
        });

    },

    setNoteSubjectsOnSearch: function() {

        this.each( function( search ) {
            search.setNoteSubjectOnSearch();
        });
    },

    resetSelectedSearch: function() {

        this.each( function( search ) {
            search.set({ isSelected: false });

        });
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/SearchModelsCollection.js
 ** module id = 585
 ** module chunks = 0
 **/